
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1836',
  depVersions: {
  "customer-portal-app": "static-1.1836",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "data-fetching-client": "static-1.9542",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.416",
  "growth-payments-core": "static-1.24908",
  "head-dlb": "static-1.4884",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5458",
  "hs-test-utils": "static-1.7872",
  "hub-http": "static-1.6083",
  "hub-http-shared-msw-handlers": "static-1.9634",
  "hubspot-dlb": "static-2.1806",
  "hubspot-prosemirror": "static-1.17791",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11308",
  "I18n": "static-7.1593",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6335",
  "payment-link-components": "static-1.23108",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6815",
  "quartz-core": "static-1.6034",
  "react": "static-7.182",
  "react-colorpicker": "static-2.10076",
  "react-dlb": "static-1.74",
  "react-utils": "static-2.5236",
  "rich-text-lib": "static-1.19585",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17754",
  "ui-components-test-utils": "static-1.5446",
  "UIComponents": "static-3.8255",
  "foundations-assets": "static-1.4706",
  "foundations-components": "static-1.7646",
  "foundations-theming": "static-1.4277",
  "foundations-theming-specialty": "static-1.1993",
  "framer-motion": "static-1.68",
  "history": "static-4.47",
  "metrics-js": "static-1.9436",
  "PortalIdParser": "static-2.377",
  "portals-platform-lib": "static-1.635",
  "quartz-config": "static-1.593",
  "quartz-routing": "static-1.245",
  "quick-fetch": "static-1.3799",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16515",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.8010",
  "styled-components": "static-2.85",
  "tanstack-table": "static-1.51",
  "ui-addon-draggable": "static-3.4633",
  "ui-addon-react-router-dom": "static-1.9410",
  "usage-tracker": "static-1.7200",
  "usage-tracker-anonymous": "static-1.5617",
  "usage-tracker-core": "static-1.7050",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3290",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3092",
  "quartz-webpack": "static-1.3039",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.78",
  "customer-data-objects": "static-1.7517",
  "frontend-preferences-client": "static-1.7789",
  "laboratory-lib": "static-3.7024",
  "onboarding-scopes": "static-1.6328",
  "rpc-client-utils": "static-1.4507",
  "ui-addon-opt": "static-4.8249",
  "HeadJS": "static-2.728",
  "hs-test-utils-bend-plugin": "static-1.2983",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "ts-schema": "static-1.3966",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7539",
  "cssUtils": "static-1.758",
  "customer-data-ui-utilities": "static-1.9689",
  "HubStyle": "static-2.11616",
  "knowledge-content-types": "static-1.8423",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.490",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.485",
  "ui-addon-emoji-picker": "static-1.9752",
  "ui-addon-i18n": "static-1.11010",
  "ui-business-units-lib": "static-1.8897",
  "ui-shepherd-react": "static-3.10011",
  "video-components-external": "static-1.10776",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4191",
  "commerce-tours-lib": "static-1.5820",
  "customer-data-properties": "static-1.50990",
  "getting-started-shared-tasks": "static-1.18060",
  "growth-onboarding-reliability": "static-1.4951",
  "onboarding-tours": "static-1.16352",
  "reference-resolvers-lite": "static-1.7950",
  "sales-checkout-service-client": "static-1.3533",
  "ui-addon-iframeable": "static-1.8912",
  "user-context": "static-1.4965",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.813",
  "hubspotter-http": "static-1.4539",
  "icons": "static-2.635",
  "mobile-manifest-mixins": "static-1.503",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.490",
  "quartz-head": "static-1.480",
  "quartz-test": "static-1.490",
  "quartz-tracking": "static-1.194",
  "ui-fonts": "static-1.570",
  "usage-tracker-container": "static-1.7190",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9291",
  "data-token-picker": "static-1.16157",
  "FileManagerLib": "static-1.38753",
  "property-translator": "static-1.5274",
  "atom": "static-1.4935",
  "merchandise-lib": "static-1.261",
  "purchase-motions-components": "static-1.5584",
  "salesImages": "static-1.522",
  "SharedI18nStrings": "static-1.181",
  "foundations-components-test-utils": "static-1.5129",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.95",
  "ui-images": "static-2.1118",
  "bend-plugin-foundations-components": "static-1.3915",
  "floating-ui": "static-1.52",
  "react-aria": "static-1.62",
  "trellis-assets": "static-1.1393",
  "bend-plugin-foundations-theming": "static-1.2760",
  "foundations-theming-base": "static-1.3262",
  "stylex": "static-1.28",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5614",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4339",
  "react-flip-move": "static-1.66",
  "bender-build-tools": "static-1.3018",
  "inbound-db-properties-service-client": "static-1.3732",
  "superstore": "static-1.4634",
  "chirp-fetch": "static-1.1748",
  "feedback-loader": "static-1.28999",
  "ai-components-ui-library": "static-1.8545",
  "ui-addon-video-player": "static-1.8561",
  "ui-coaching-tips": "static-1.28114",
  "sassPrefix": "static-1.153",
  "react-dnd-compat": "static-1.4485",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2357",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8029",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4516",
  "content-media-composition-data-lib": "static-1.11718",
  "content-media-compositions": "static-2.15725",
  "idb-keyval": "static-1.40",
  "immer": "static-1.33",
  "immerable": "static-1.4019",
  "magpie-lib": "static-1.5459",
  "magpie-types": "static-1.4919",
  "media-bridge-lib": "static-1.18679",
  "video-data-lib": "static-1.34434",
  "commerce-products-lib": "static-1.9025",
  "crm-message-bus": "static-1.42560",
  "growth-data-modal": "static-1.5224",
  "hubspot-apollo-client": "static-1.4744",
  "onboarding-tours-client": "static-1.4566",
  "calling-global-api": "static-1.63924",
  "calling-internal-common": "static-1.31165",
  "calling-lifecycle-internal": "static-1.65306",
  "calling-lifecycle-messages": "static-1.57600",
  "conditional-properties-service-client": "static-1.3684",
  "crm-links": "static-1.6134",
  "customer-data-objects-ui-components": "static-1.12877",
  "customer-data-property-utils": "static-1.7945",
  "external-options-client-types": "static-1.4045",
  "file-manager-components": "static-1.23113",
  "framework-data-schema-resolvers": "static-1.6738",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.552",
  "inbound-db-meta-service-client": "static-1.3481",
  "inbounddb-objects-service-types": "static-1.4109",
  "meetings-icalendar-utils-lib": "static-1.497",
  "multi-currency-client-types": "static-1.3576",
  "object-builder-ui-client": "static-1.48216",
  "pipeline-validation-client-types": "static-1.3850",
  "property-value-citations": "static-1.1604",
  "pulse": "static-1.389",
  "smart-property-lib": "static-1.6183",
  "tiered-pricing": "static-1.930",
  "ui-addon-form-validation": "static-1.10858",
  "growth-onboarding-confetti": "static-1.2937",
  "growth-onboarding-next-action-utils": "static-1.1466",
  "navigation-components": "static-1.17486",
  "onboarding-tours-utils": "static-1.418",
  "ui-shepherd-tracker": "static-1.7392",
  "ui-universal-auth": "static-1.8787",
  "batch-promise": "static-1.1416",
  "navigation-messaging": "static-1.6813",
  "getting-started-shared-tasks-store": "static-1.17178",
  "hubspotter-http-shared-msw-handlers": "static-1.9632",
  "usage-tracker-session-replay": "static-1.4886",
  "audio-components": "static-1.5703",
  "FileManagerCore": "static-1.38612",
  "FileManagerImages": "static-1.36264",
  "video-components": "static-1.12779",
  "foundations-components-legacy": "static-1.671",
  "growth-monetization-service-types": "static-1.4364",
  "nav-client-types": "static-1.2222",
  "purchase-motions-api": "static-1.5587",
  "self-service-api": "static-1.10107",
  "signup-constants": "static-1.18535",
  "signup-ui-url-generator": "static-2.7900",
  "trials-service-types": "static-1.3765",
  "usage-tracker-public": "static-1.7011",
  "chatspot-core": "static-1.20607",
  "ContentUtils": "static-1.67821",
  "copilot-toolkit": "static-1.10703",
  "growth-onboarding-feedback-components": "static-1.6446",
  "reactive-lib": "static-1.590",
  "simple-logging-lib": "static-1.2915",
  "commerce-permissions": "static-1.628",
  "customer-data-tracking": "static-1.6747",
  "products-iframe-lib": "static-1.7510",
  "products-ui-components-shared-msw-handlers": "static-1.10016",
  "hubspot-apollo-cache": "static-1.203",
  "calling-error-reporting": "static-1.31171",
  "shared-worker-versioning": "static-1.10904",
  "calling-usage-tracker": "static-1.6406",
  "voice-sms-access-library": "static-1.433",
  "conversations-skeleton-state": "static-1.7114",
  "location-customization-utils-lib": "static-1.8764",
  "crm-pipelines-api-client-types": "static-1.4026",
  "framework-builder-read-service-client": "static-1.3894",
  "framework-data-schema-quick-fetch": "static-1.6643",
  "persist-promise": "static-1.3573",
  "directed-graph": "static-1.804",
  "event-emitter": "static-1.812",
  "fast-json-patch": "static-1.59",
  "breeze-intelligence-kit": "static-1.5413",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9717",
  "fsm": "static-1.3595",
  "policy-lib": "static-1.6643",
  "react-tinymce": "static-1.54804",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9780",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53930",
  "tinymce-plugins": "static-1.57044",
  "tinymce-themes": "static-1.55900",
  "growth-onboarding-next-action-components": "static-1.1494",
  "user-context-client": "static-1.4477",
  "unified-auth-core-lib": "static-1.582",
  "amplitude-session-replay-browser": "static-1.56",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4396",
  "video-embed": "static-1.35268",
  "content-icons-ui": "static-1.2182",
  "social-insights-client-types": "static-1.21574",
  "eligibility-engine-service-types": "static-1.3046",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4674",
  "integrations-lib": "static-1.15625",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4135",
  "calling-orchestration-schema": "static-1.35210",
  "crm-record-cards-service-types": "static-1.3503",
  "highcharts": "static-8.100",
  "trellis-story-utils": "static-1.4385",
  "storybook-react": "static-1.29",
  "hub-http-contrib": "static-1.2908",
  "interframe": "static-3.4627",
  "tinymce-data": "static-1.40015",
  "ui-addon-sales-email": "static-1.5078",
  "codemirror": "static-5.91",
  "layout-dnd-components": "static-1.12168",
  "layout-dnd-utils": "static-1.11143",
  "react-codemirror": "static-1.10491",
  "ui-brand-identity-lib": "static-1.14349",
  "NamespacedHubStyle": "static-2.8956",
  "outpost": "static-1.4064",
  "flux-actions": "static-1.321",
  "integrations-error-boundary-lib": "static-1.13040",
  "integrations-tracking-lib": "static-1.5455",
  "native-integrations-shared-strings": "static-1.7652",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10239",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67896",
  "layout-data-lib": "static-1.9468",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2866",
  "advanced-menus-core": "static-1.14909",
  "advanced-menus-lib": "static-1.11877",
  "ExportDialog": "static-6.10253",
  "ui-memberships-settings-lib": "static-1.33621",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14908",
  "simple-menus-lib": "static-1.16425"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1836",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "data-fetching-client": "/data-fetching-client/static-1.9542",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.416",
  "growth-payments-core": "/growth-payments-core/static-1.24908",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5458",
  "hs-test-utils": "/hs-test-utils/static-1.7872",
  "hub-http": "/hub-http/static-1.6083",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9634",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17791",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11308",
  "I18n": "/I18n/static-7.1593",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6335",
  "payment-link-components": "/payment-link-components/static-1.23108",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6815",
  "quartz-core": "/quartz-core/static-1.6034",
  "react": "/react/static-7.182",
  "react-colorpicker": "/react-colorpicker/static-2.10076",
  "react-dlb": "/react-dlb/static-1.74",
  "react-utils": "/react-utils/static-2.5236",
  "rich-text-lib": "/rich-text-lib/static-1.19585",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17754",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5446",
  "UIComponents": "/UIComponents/static-3.8255",
  "foundations-assets": "/foundations-assets/static-1.4706",
  "foundations-components": "/foundations-components/static-1.7646",
  "foundations-theming": "/foundations-theming/static-1.4277",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1993",
  "framer-motion": "/framer-motion/static-1.68",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9436",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "portals-platform-lib": "/portals-platform-lib/static-1.635",
  "quartz-config": "/quartz-config/static-1.593",
  "quartz-routing": "/quartz-routing/static-1.245",
  "quick-fetch": "/quick-fetch/static-1.3799",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16515",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.8010",
  "styled-components": "/styled-components/static-2.85",
  "tanstack-table": "/tanstack-table/static-1.51",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4633",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9410",
  "usage-tracker": "/usage-tracker/static-1.7200",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5617",
  "usage-tracker-core": "/usage-tracker-core/static-1.7050",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3290",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3092",
  "quartz-webpack": "/quartz-webpack/static-1.3039",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.78",
  "customer-data-objects": "/customer-data-objects/static-1.7517",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7789",
  "laboratory-lib": "/laboratory-lib/static-3.7024",
  "onboarding-scopes": "/onboarding-scopes/static-1.6328",
  "rpc-client-utils": "/rpc-client-utils/static-1.4507",
  "ui-addon-opt": "/ui-addon-opt/static-4.8249",
  "HeadJS": "/HeadJS/static-2.728",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2983",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "ts-schema": "/ts-schema/static-1.3966",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7539",
  "cssUtils": "/cssUtils/static-1.758",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9689",
  "HubStyle": "/HubStyle/static-2.11616",
  "knowledge-content-types": "/knowledge-content-types/static-1.8423",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.490",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9752",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11010",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8897",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10011",
  "video-components-external": "/video-components-external/static-1.10776",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4191",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5820",
  "customer-data-properties": "/customer-data-properties/static-1.50990",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18060",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4951",
  "onboarding-tours": "/onboarding-tours/static-1.16352",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7950",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3533",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8912",
  "user-context": "/user-context/static-1.4965",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.813",
  "hubspotter-http": "/hubspotter-http/static-1.4539",
  "icons": "/icons/static-2.635",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.503",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.490",
  "quartz-head": "/quartz-head/static-1.480",
  "quartz-test": "/quartz-test/static-1.490",
  "quartz-tracking": "/quartz-tracking/static-1.194",
  "ui-fonts": "/ui-fonts/static-1.570",
  "usage-tracker-container": "/usage-tracker-container/static-1.7190",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9291",
  "data-token-picker": "/data-token-picker/static-1.16157",
  "FileManagerLib": "/FileManagerLib/static-1.38753",
  "property-translator": "/property-translator/static-1.5274",
  "atom": "/atom/static-1.4935",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "purchase-motions-components": "/purchase-motions-components/static-1.5584",
  "salesImages": "/salesImages/static-1.522",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5129",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.95",
  "ui-images": "/ui-images/static-2.1118",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3915",
  "floating-ui": "/floating-ui/static-1.52",
  "react-aria": "/react-aria/static-1.62",
  "trellis-assets": "/trellis-assets/static-1.1393",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2760",
  "foundations-theming-base": "/foundations-theming-base/static-1.3262",
  "stylex": "/stylex/static-1.28",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5614",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4339",
  "react-flip-move": "/react-flip-move/static-1.66",
  "bender-build-tools": "/bender-build-tools/static-1.3018",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3732",
  "superstore": "/superstore/static-1.4634",
  "chirp-fetch": "/chirp-fetch/static-1.1748",
  "feedback-loader": "/feedback-loader/static-1.28999",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8545",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8561",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28114",
  "sassPrefix": "/sassPrefix/static-1.153",
  "react-dnd-compat": "/react-dnd-compat/static-1.4485",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2357",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8029",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4516",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11718",
  "content-media-compositions": "/content-media-compositions/static-2.15725",
  "idb-keyval": "/idb-keyval/static-1.40",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4019",
  "magpie-lib": "/magpie-lib/static-1.5459",
  "magpie-types": "/magpie-types/static-1.4919",
  "media-bridge-lib": "/media-bridge-lib/static-1.18679",
  "video-data-lib": "/video-data-lib/static-1.34434",
  "commerce-products-lib": "/commerce-products-lib/static-1.9025",
  "crm-message-bus": "/crm-message-bus/static-1.42560",
  "growth-data-modal": "/growth-data-modal/static-1.5224",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4744",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4566",
  "calling-global-api": "/calling-global-api/static-1.63924",
  "calling-internal-common": "/calling-internal-common/static-1.31165",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65306",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57600",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3684",
  "crm-links": "/crm-links/static-1.6134",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12877",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7945",
  "external-options-client-types": "/external-options-client-types/static-1.4045",
  "file-manager-components": "/file-manager-components/static-1.23113",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6738",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.552",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3481",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4109",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.497",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3576",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48216",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3850",
  "property-value-citations": "/property-value-citations/static-1.1604",
  "pulse": "/pulse/static-1.389",
  "smart-property-lib": "/smart-property-lib/static-1.6183",
  "tiered-pricing": "/tiered-pricing/static-1.930",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10858",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2937",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1466",
  "navigation-components": "/navigation-components/static-1.17486",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.418",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7392",
  "ui-universal-auth": "/ui-universal-auth/static-1.8787",
  "batch-promise": "/batch-promise/static-1.1416",
  "navigation-messaging": "/navigation-messaging/static-1.6813",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17178",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9632",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4886",
  "audio-components": "/audio-components/static-1.5703",
  "FileManagerCore": "/FileManagerCore/static-1.38612",
  "FileManagerImages": "/FileManagerImages/static-1.36264",
  "video-components": "/video-components/static-1.12779",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.671",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4364",
  "nav-client-types": "/nav-client-types/static-1.2222",
  "purchase-motions-api": "/purchase-motions-api/static-1.5587",
  "self-service-api": "/self-service-api/static-1.10107",
  "signup-constants": "/signup-constants/static-1.18535",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7900",
  "trials-service-types": "/trials-service-types/static-1.3765",
  "usage-tracker-public": "/usage-tracker-public/static-1.7011",
  "chatspot-core": "/chatspot-core/static-1.20607",
  "ContentUtils": "/ContentUtils/static-1.67821",
  "copilot-toolkit": "/copilot-toolkit/static-1.10703",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6446",
  "reactive-lib": "/reactive-lib/static-1.590",
  "simple-logging-lib": "/simple-logging-lib/static-1.2915",
  "commerce-permissions": "/commerce-permissions/static-1.628",
  "customer-data-tracking": "/customer-data-tracking/static-1.6747",
  "products-iframe-lib": "/products-iframe-lib/static-1.7510",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10016",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.203",
  "calling-error-reporting": "/calling-error-reporting/static-1.31171",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10904",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6406",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.433",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7114",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8764",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4026",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3894",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6643",
  "persist-promise": "/persist-promise/static-1.3573",
  "directed-graph": "/directed-graph/static-1.804",
  "event-emitter": "/event-emitter/static-1.812",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5413",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9717",
  "fsm": "/fsm/static-1.3595",
  "policy-lib": "/policy-lib/static-1.6643",
  "react-tinymce": "/react-tinymce/static-1.54804",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9780",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53930",
  "tinymce-plugins": "/tinymce-plugins/static-1.57044",
  "tinymce-themes": "/tinymce-themes/static-1.55900",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1494",
  "user-context-client": "/user-context-client/static-1.4477",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.582",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4396",
  "video-embed": "/video-embed/static-1.35268",
  "content-icons-ui": "/content-icons-ui/static-1.2182",
  "social-insights-client-types": "/social-insights-client-types/static-1.21574",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3046",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4674",
  "integrations-lib": "/integrations-lib/static-1.15625",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35210",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3503",
  "highcharts": "/highcharts/static-8.100",
  "trellis-story-utils": "/trellis-story-utils/static-1.4385",
  "storybook-react": "/storybook-react/static-1.29",
  "hub-http-contrib": "/hub-http-contrib/static-1.2908",
  "interframe": "/interframe/static-3.4627",
  "tinymce-data": "/tinymce-data/static-1.40015",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5078",
  "codemirror": "/codemirror/static-5.91",
  "layout-dnd-components": "/layout-dnd-components/static-1.12168",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11143",
  "react-codemirror": "/react-codemirror/static-1.10491",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14349",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8956",
  "outpost": "/outpost/static-1.4064",
  "flux-actions": "/flux-actions/static-1.321",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13040",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5455",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7652",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10239",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67896",
  "layout-data-lib": "/layout-data-lib/static-1.9468",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2866",
  "advanced-menus-core": "/advanced-menus-core/static-1.14909",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11877",
  "ExportDialog": "/ExportDialog/static-6.10253",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33621",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14908",
  "simple-menus-lib": "/simple-menus-lib/static-1.16425"
}
};
